/* A régi fmt* helperek a közös magyar formázóra (utils/fmt.js) mutatnak —
   így minden meglévő hívás magyar formátumot kap (3a). */
import { fmtPrice as huPrice, fmtPct as huPct, fmtCompact } from './fmt';

export function fmtPrice(n) {
  if (n === null || n === undefined) return '—';
  return huPrice(n);
}

export function fmtPct(n, dec = 2) {
  if (n === null || n === undefined) return '—';
  return huPct(n, dec);
}

export function fmtMktCap(n) {
  if (!n) return '—';
  return fmtCompact(n);
}

export function fmtSupply(n) {
  if (!n) return '—';
  return fmtCompact(n, { unit: '' });
}

/* Alternative.me returns the Fear & Greed classification in English. */
const FNG_HU = {
  'extreme fear': 'Extrém félelem',
  'fear': 'Félelem',
  'neutral': 'Semleges',
  'greed': 'Mohóság',
  'extreme greed': 'Extrém mohóság',
};
export function fngLabel(cls) {
  return FNG_HU[String(cls ?? '').toLowerCase()] ?? cls ?? '';
}
